import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "../styles/analytics.css";
import useFeedbackPopup from "../custom-hooks/useFeedbackPopup";

const FeedbackPopup = ({ show, handleClose, fingerprint }) => {
  const {
    feature_request,
    setFeature_request,
    collection_request,
    setCollection_request,
    handleSubmit,
  } = useFeedbackPopup({ show, handleClose, fingerprint });

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
      <div className="modal-header-style">
        <div className="modal-flex-box">
          <h4 className="modal-title-style">Feedback</h4>
          <button
            type="button"
            className="close modal-close-style"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <hr className="line-style" />
      </div>
      <Modal.Body>
        <div
          style={{
            padding: "1rem",
            fontFamily: "Roboto",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <label>
            What new features would you like to see added to the website?
            <textarea
              style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                resize: "vertical",
              }}
              value={feature_request}
              onChange={(e) => setFeature_request(e.target.value)}
            />
          </label>
          <label>
            Do you have any publications you would like added to the database?{" "}
            <br></br>
            If you do then please provide as many details as you can about the
            publication (title, years, where extranet copies are held, etc.)
            <input
              style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
              type="text"
              value={collection_request}
              onChange={(e) => setCollection_request(e.target.value)}
            />
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleSubmit}
          className="active-button"
          style={{ marginRight: "25px" }}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackPopup;
